import {IDemoButtonProps} from './types';
import {Button} from 'kui';
import * as React from 'react';
import './_DemoButton.scss';
import { DEMO_BUTTON_BUTTON, DEMO_BUTTON_PURCHASE, DEMO_BUTTON_TEXT, DEMO_BUTTON_TITLE } from './constants';

export function DemoButton ({
    price,
    onClick,
    onPurchaseClick,
}: IDemoButtonProps) {
    const className = 'demo-button';

    return (
        <div className={className}>
            <div
                className={className + '__label'}
            >
                <div
                    className={className + '__title'}
                >
                    {DEMO_BUTTON_TITLE}
                </div>
                <div
                    className={className + '__text'}
                >
                    {DEMO_BUTTON_TEXT}
                </div>
            </div>
            <div className={className + '__buttons'}>
                <Button
                    className={className + '__button'}
                    size={'large'}
                    variant={'primary'}
                    onClick={onClick}
                >
                    {DEMO_BUTTON_BUTTON}
                </Button>
                <Button
                    className={`
                        ${className}__button
                        ${className}__button--purchase
                    `}
                    size={'large'}
                    variant={'text'}
                    onClick={onPurchaseClick}
                    href={'https://www.kanbanchi.com/pricing'}
                >
                    {DEMO_BUTTON_PURCHASE}
                </Button>
            </div>
        </div>
    );
};
